'use client'

import { useEffect } from 'react'

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const isStaleAction = error.message?.includes('Failed to find Server Action')

  useEffect(() => {
    // Auto-reload for stale Server Action errors — the VersionChecker banner
    // should normally catch deploys before this fires, but this is the fallback.
    if (isStaleAction) {
      window.location.reload()
    }
  }, [isStaleAction])

  if (isStaleAction) {
    return (
      <html>
        <body className="flex min-h-screen items-center justify-center bg-gray-950 text-gray-100">
          <div className="space-y-2 text-center">
            <p className="text-sm text-gray-400">Updating to the latest version...</p>
          </div>
        </body>
      </html>
    )
  }

  return (
    <html>
      <body className="flex min-h-screen items-center justify-center bg-gray-950 text-gray-100">
        <div className="space-y-4 text-center">
          <h2 className="text-xl font-semibold">Something went wrong</h2>
          <p className="text-sm text-gray-400">
            An unexpected error occurred. Please reload the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="rounded bg-indigo-600 px-4 py-2 text-sm transition-colors hover:bg-indigo-500"
          >
            Reload
          </button>
        </div>
      </body>
    </html>
  )
}
